<script setup>
import NavBar from '@/components/NavBar'
import Header from '@/components/HeaderComponent'
import Overview from '@/components/Overview'
import Registration from '@/components/Registration'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
import Submission from '@/components/Submission'
import Scheduler from '@/components/Scheduler'
import Organizers from '@/components/Organizers'
import Speakers from '@/components/Speakers'
import Sponsors from '@/components/Sponsors'
import AgendaDetails from '@/components/AgendaDetails.vue'
import {inject} from 'vue'
import Award from '@/components/Award'
import RegistrationPht from '@/components/RegistrationPht.vue'
import CallForAbstracts from '@/components/CallForAbstracts.vue'
import PanelDiscussion from '@/components/PanelDiscussion.vue'
import axios from 'axios'
import {ref, onMounted} from 'vue'

const blocks = ref([])

onMounted(async () => {
    blocks.value = await getBlocksData(blocksURL)
})

const contentData = inject('contentData')

const mainTitle = document.getElementById('mainTitle')
const favicon = document.getElementById('favicon')
if (contentData.what === 'rn') {
    mainTitle.innerHTML = 'Swiss Reproducibility Conference 2024'
    // favicon.href = '<%= BASE_URL %>iconRN.ico"'
}

const blocksURL = 'api/blocks'

const backEndURL = process.env.VUE_APP_BACKEND_URL

const getBlocksData = async () => {
    try {
        const res = await axios.get(`${backEndURL}/${blocksURL}`)

        return res.data.map(block => {
            return {
                ...block,
                block_elements: createBlockElementsObject(block.block_elements),
            }
        })
    } catch (err) {
        console.error(err)
    }
}

const createBlockElementsObject = (blockElements = []) => {
    const obj = {}

    // If it's not an array, return an empty object safely
    if (!Array.isArray(blockElements)) {
        return obj
    }

    for (const item of blockElements) {
        if (!item || !item.name) continue // skip invalid items

        obj[item.name] = {
            content: item.text ?? '', // fallback to empty string
            display: item.display ?? true, // fallback to true
        }
    }

    return obj
}

const filterBlockByTitle = title => {
    if (!blocks.value || blocks.value.length === 0) {
        return {}
    }

    const block = blocks.value.find(b => b?.title === title)

    if (!block || !block.block_elements) {
        return {}
    }

    return block.block_elements
}

const checkIfBlockDisplay = title => {
    if (!blocks.value || blocks.value.length === 0) {
        return false
    }

    const block = blocks.value.find(b => b?.title === title)

    if (!block || typeof block.display === 'undefined') {
        return false
    }

    return block.display
}
</script>

<template>
    <div class="relative" v-if="blocks.length > 0 && contentData.what !== 'rn'">
        <NavBar />
        <Header :data="filterBlockByTitle('Header')" />

        <Overview
            v-if="contentData.overview.display && checkIfBlockDisplay('Overview')"
            :data="filterBlockByTitle('Overview')" />
        <Scheduler
            v-if="contentData.sessions.display && checkIfBlockDisplay('Scheduler')"
            :data="filterBlockByTitle('Scheduler')" />
        <AgendaDetails v-if="contentData.sessions.display && contentData.what === 'rn'" />
        <Award v-if="contentData.award.display" />
        <!--        <Speakers v-if="contentData.speakers.display" />-->
        <!--        <AgendaDetails v-if="contentData.sessions.display && contentData.what === 'pht'" />-->
        <PanelDiscussion
            :data="filterBlockByTitle('Panel_Discussion')"
            v-if="checkIfBlockDisplay('Panel_Discussion')" />
        <Registration v-if="contentData.registration.display && contentData.what === 'rn'" />
        <RegistrationPht
            v-if="contentData.what === 'pht' && checkIfBlockDisplay('Registration')"
            :data="filterBlockByTitle('Registration')" />
        <Submission v-if="contentData.submission.display" />
        <Sponsors :data="filterBlockByTitle('Sponsors')" v-if="checkIfBlockDisplay('Sponsors')" />
        <CallForAbstracts
            :data="filterBlockByTitle('Call_for_abstracts')"
            v-if="checkIfBlockDisplay('Call_for_abstracts')" />
        <Organizers />
        <Contact />
        <Footer />
    </div>
    <!--I will refactro this part later-->
    <div class="relative" v-if="contentData.what === 'rn'">
        <NavBar />
        <Header :data="filterBlockByTitle('Header')" />
        <Overview v-if="contentData.overview.display" />
        <Scheduler v-if="contentData.sessions.display" />
        <AgendaDetails v-if="contentData.sessions.display && contentData.what === 'rn'" />
        <Award v-if="contentData.award.display" />
        <Speakers v-if="contentData.speakers.display" />
        <PanelDiscussion v-if="checkIfBlockDisplay('Panel_Discussion')" />
        <Registration v-if="contentData.registration.display && contentData.what === 'rn'" />
        <Submission v-if="contentData.submission.display" />
        <Organizers />
        <Contact />
        <Footer />
    </div>
</template>

<style scoped></style>
